import { AppRouteName } from '../types/core'
import { AdLayoutConfig, adLayoutName, AdLayoutName } from '../types/site'

export const DEFAULT_LAYOUT = 2

export const NO_SIDEVIEW_ROUTES: AppRouteName[] = [
  'toDashboard',
  'toCitationsDashboard',
  'toCitationList',
  'toCitationListForm',
  'toCitationListSource',
]

const definedLayouts: AdLayoutConfig[] = [
  // w482px sideframe
  {
    startWidth: 1280,
    name: adLayoutName.xl,
  },
  // w400px sideframe
  {
    startWidth: 1200,
    name: adLayoutName.lg,
  },
  // w300px sideframe
  {
    startWidth: 620,
    name: adLayoutName.md,
  },
  // no sideframe
  {
    startWidth: 0,
    name: adLayoutName.sm,
  },
]

export const layoutNameFromWidth = (observedWidth: number = 0): AdLayoutName => {
  const firstMatchingLayout = ({ startWidth }) => observedWidth - startWidth >= 0
  const { name } =
    definedLayouts.find(firstMatchingLayout) || definedLayouts[DEFAULT_LAYOUT]

  return name
}

export const hasSideViewForRoute = (routeName: AppRouteName) => {
  return !NO_SIDEVIEW_ROUTES.includes(routeName)
}
